import { useEffect } from 'react'
import { router } from '@inertiajs/react'
import consumer from '@/channels/consumer'
import { FileExplorerItem } from '@features/file-explorer/types'

interface UseDocumentSubscriptionsProps {
  items: FileExplorerItem[]
}

export function useDocumentSubscriptions({ items }: UseDocumentSubscriptionsProps) {
  useEffect(() => {
    // Get all documents that don't have preview_url yet (derivatives processing)
    const processingDocuments = items.filter(
      item => item.type === 'Document' && !item.preview_url
    )

    if (processingDocuments.length === 0) {
      return // No documents to subscribe to
    }

    // Subscribe to each processing document
    const subscriptions = processingDocuments.map(doc => {
      return consumer.subscriptions.create(
        { channel: 'DocumentChannel', id: doc.id },
        {
          received(data: any) {
            if (data.type === 'derivatives_ready') {
              // Reload items to get updated preview URLs
              router.reload({
                except: ['pagination', 'breadcrumbs', 'folder_tree', 'storage_usage']
              })
            }
          }
        }
      )
    })

    // Cleanup: unsubscribe from all channels when component unmounts or items change
    return () => {
      subscriptions.forEach(subscription => subscription.unsubscribe())
    }
  }, [items])
}
